import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import SimpleReactValidator from 'simple-react-validator';
import { createPickupDrop, getPickupDropListDetails, editPickupDrop } from "../../redux/actions/master"

class PickupAndDropLocationModalClass extends Component {

	state = {
		pickupDropDetails: {
            title: '',

		},
		isEdit: false,
	}

	componentWillMount() {
		this.validator = new SimpleReactValidator({
			element: message => <span className="error-message ">{message}</span>,
			autoForceUpdate: this,
			messages: {}
		});
	}

	componentWillReceiveProps(props) {

		let { modalDetails, isEdit } = props

		this.setState({
			pickupDropDetails: modalDetails,
			isEdit: isEdit,
		})
	}

	handleInputs = ({ target: { value, name } }) => {

		let pickupDropDetails = Object.assign({}, this.state.pickupDropDetails)

		pickupDropDetails[name] = value

		this.setState({
			pickupDropDetails
		})


	}

	handleSubmit = () => {

		if (this.validator.allValid()) {

			let { pickupDropDetails: { title, id = '' }, isEdit } = this.state

			let body = {
                title: title,
                status:1
			}

			if (!isEdit) {

				this.props.createPickupDrop(body).then(() => {

					this.props.getPickupDropListDetails().then(() => {
						let temp = {
                            title: '',
						}

						this.setState({
							isEdit: false,
							pickupDropDetails: temp

						})
					})
				})
			} else {

				this.props.editPickupDrop(id, body).then((message) => {

					this.props.getPickupDropListDetails().then(() => {
						let temp = {
                            title: '',
						}

						this.setState({
							isEdit: false,
							pickupDropDetails: temp

						})
					})

				})
			}
			this.props.toggle()

			this.validator.hideMessages();

		} else {
			this.setState({
				isError: true
			})
			this.validator.showMessages();

		}
	}
	render() {

		let { isError, isEdit, toggle } = this.props

		let { pickupDropDetails } = this.state

		this.validator.purgeFields();
		let { title } = pickupDropDetails

		return (
			<section className="side-slider h-100">
				<div className="slider-header p-4">
					<div className="d-flex align-items-center">
						<h5 className="sair-sec-title"> {isEdit ? "Edit Pickup/Drop Option" : "Add Pickup/Drop Option"}</h5>
						<div className="ml-auto">
							<i className="icon-close font-md px-2 cursor-pointer"
								onClick={toggle}
							></i>
						</div>
					</div>
				</div>
				<div className="slider-body p-4">
					<div className={`row no-gutters ${isError ? "was-validated" : ""}`}>
						<div className="col-md-12 form-group">
							<label>PickUp/Drop Option</label>
							<input
								className={`form-control ${this.validator.message('title', title, 'required') ? 'inValid' : ''}`} id="title"
								placeholder=""
								name="title"
								value={title}
								type="text"
								onChange={this.handleInputs}


							/>
							{this.validator.message('title', title, 'required')}
						</div>

					</div>

					<hr />
					<button
						className="btn btn-primary"

						onClick={() => this.handleSubmit()}

					>{isEdit ? "Update" : "Submit"}</button>
				</div>
			</section>
		)
	}
}

const mapStateToProps = state => {

	return {}

};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		createPickupDrop,
		getPickupDropListDetails,
		editPickupDrop
	}, dispatch)
};



export const PickupAndDropLocationModal = connect(mapStateToProps, mapDispatchToProps)(PickupAndDropLocationModalClass)
